import { ReactNode } from 'react';
import { fullScreenChildGridClasses } from '@/styles/grid';
import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';

type Props = {
  isVisible: boolean;
  bgTransparent?: boolean;
  children?: ReactNode;
};

const LightBox = ({ isVisible, bgTransparent = false, children }: Props) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className={clsx(
            fullScreenChildGridClasses,
            `fixed left-0 top-0 z-[101] h-full w-full gap-y-16 overflow-y-scroll ${
              bgTransparent ? 'bg-transparent' : 'bg-white-15'
            }`
          )}
        >
          <motion.div
            initial={{ y: 50 }}
            animate={{ y: 0 }}
            exit={{ y: 50 }}
            className="col-span-full mx-auto my-12 max-w-screen-xl"
          >
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LightBox;
